(function () {
	'use strict';

	angular.module('app.core')
		.directive('scrollWatch', scrollWatch);

	scrollWatch.$inject = ['$window', '$timeout'];
	function scrollWatch($window, $timeout) {
		return function (scope, element, attr) {
			var w = angular.element($window);
			
			function getHeaderOffset() {
				if (scope.$parent.$parent.sidebarOnlyMode) {
					return -6;
				}
				return 86; // current header height
			}
			function updateModalHeight() {
				if (jQuery('.modal.fade.right').length) {
					// TODO rework to remove this jquery hard set styles and use css to stretch right side angular modals if it keeps being a problem
					jQuery('.modal.fade.right').css('top', 0 + 'px');
					jQuery('.modal.fade.right .modal-body').css('height', (jQuery(window).height() - getHeaderOffset()) + 'px');
				}
			}

			updateModalHeight();
			w.on('scroll', updateModalHeight);
			w.on('resize', updateModalHeight);

			scope.$on('$destroy', function () {
				w.off('scroll', updateModalHeight);
				w.off('resize', updateModalHeight);
			});
		};
	}
})();
